import React from "react"
import { Button } from "reactstrap"

export default function IconButton({ children, ...rest }) {
    return (
        <Button {...rest}>
            {children}
        </Button>
    )
}